export default __webpack_public_path__ + "static/media/ThinkContractCompliance.f7a03c1ef36c7f98f241f0444ae5051a.webp";